import React from 'react';
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { NegoceFiltersProvider } from './NegoceFilters';
import { NegoceSynthesis } from './Synthesis';
import { NegoceRankings } from './Rankings';
import { NegocePresentation } from './Presentation';
import { NegoceRawData } from './RawData';
import { TabBar } from '../../components/TabBar';

// ─── Tab Navigation ─────────────────────────────────────────────────────────

const TABS = [
  { id: 'synthesis', label: 'Synthesis', path: 'synthesis' },
  { id: 'rankings', label: 'Rankings', path: 'rankings' },
  { id: 'presentation', label: 'Presentation', path: 'presentation' },
  { id: 'raw-data', label: 'Raw Data', path: 'raw-data' }
] as const;

// ─── Component ──────────────────────────────────────────────────────────────

export const NegoceStats: React.FC<RouteComponentProps> = ({
  match,
  location,
  history
}) => {
  const activeTab =
    TABS.find((t) => location.pathname.includes(t.path))?.id || 'synthesis';

  return (
    <NegoceFiltersProvider>
      <PageShell>
        <TabBar
          tabs={TABS.map((t) => ({ id: t.id, label: t.label }))}
          activeTab={activeTab}
          onTabChange={(id) => {
            const tab = TABS.find((t) => t.id === id);
            if (tab) history.push(`${match.url}/${tab.path}`);
          }}
        />

        <Content>
          <Switch>
            <Route
              path={`${match.path}/synthesis`}
              component={NegoceSynthesis}
            />
            <Route path={`${match.path}/rankings`} component={NegoceRankings} />
            <Route
              path={`${match.path}/presentation`}
              component={NegocePresentation}
            />
            <Route path={`${match.path}/raw-data`} component={NegoceRawData} />
            <Redirect from={match.path} to={`${match.path}/synthesis`} />
          </Switch>
        </Content>
      </PageShell>
    </NegoceFiltersProvider>
  );
};

// ─── Styled ─────────────────────────────────────────────────────────────────

const PageShell = styled.div``;

const Content = styled.div``;
